/******************************************************************
 * map icons
 *****************************************************************/

//convert data attribute to class name
$(function () {
    function mapIcons() {
        if (!window.iconMapObj) {
            return;
        }

        var elements = $('[data-iconmap]');
        for (var i = 0; i < elements.length; i++) {
            $(elements[i]).addClass(window.iconMapObj[$(elements[i]).data('iconmap')]);
        }
    }

    mapIcons();
    window.MvpFE.mapIcons = mapIcons;
    window.MvpFE.rebindFunctions.mapIcons = mapIcons;
});